import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-52f5c666"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "file-content" }
const _hoisted_2 = { class: "file-type-label" }
const _hoisted_3 = { class: "file-name" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "file-type-icon",
      style: _normalizeStyle({ '--file-icon-color': _ctx.iconInfo.color })
    }, [
      _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.iconInfo.label), 1)
    ], 4),
    _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.displayName), 1)
  ]))
}